import React from 'react';
import PropTypes from "prop-types";

export default function MobileScreenshotSVG(props) {
  return (
    <svg 
      width={props.styles.width} 
      height={props.styles.height}
      fill={props.styles.fill}
      id={props.id || ''}
      className={props.className || ''}
      version="1.1"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <title>Icon/Ticket Type/Mobile Screenshot</title>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" width={props.styles.width} height={props.styles.height}>
        <g id="Icon/Ticket-Type/Mobile-Screenshot" fill={props.styles.fill}>
          <path d="M23,0 C24.6568542,-3.04359188e-16 26,1.34314575 26,3 L26,29 C26,30.6568542 24.6568542,32 23,32 L10,32 C8.34314575,32 7,30.6568542 7,29 L7,3 C7,1.34314575 8.34314575,3.04359188e-16 10,0 L23,0 Z M22.5,2.5 L10.5,2.5 C9.98716416,2.5 9.56449284,2.88604019 9.50672773,3.38337887 L9.5,3.5 L9.5,28.5 C9.5,29.0128358 9.88604019,29.4355072 10.3833789,29.4932723 L10.5,29.5 L22.5,29.5 C23.0128358,29.5 23.4355072,29.1139598 23.4932723,28.6166211 L23.5,28.5 L23.5,3.5 C23.5,2.94771525 23.0522847,2.5 22.5,2.5 Z M16.5,25.5 C17.3284271,25.5 18,26.1715729 18,27 C18,27.8284271 17.3284271,28.5 16.5,28.5 C15.6715729,28.5 15,27.8284271 15,27 C15,26.1715729 15.6715729,25.5 16.5,25.5 Z M12.5,19 L12.5,21 L11.7,21 L11.7,19.8 L10.5,19.8 L10.5,19 L12.5,19 Z M22.5,19 L22.5,19.8 L21.3,19.8 L21.3,21 L20.5,21 L20.5,19 L22.5,19 Z M20.5,11 L20.5,19 L12.5,19 L12.5,11 L20.5,11 Z M19.1666667,12.3333333 L13.8333333,12.3333333 L13.8333333,17.6666667 L19.1666667,17.6666667 L19.1666667,12.3333333 Z M12.5,9 L12.5,11 L10.5,11 L10.5,10.2 L11.7,10.2 L11.7,9 L12.5,9 Z M21.3,9 L21.3,10.2 L22.5,10.2 L22.5,11 L20.5,11 L20.5,9 L21.3,9 Z" id="mobile-screenshot-1"></path>
        </g>
      </g>
    </svg>
  );
}

MobileScreenshotSVG.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.shape({
    fill: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string
  })
};
